export const MandatoryFieldsMarker = () => (
  <div className="text-navy-navy col-span-6 text-xs">
    <label className="mr-1">*Diese Felder sind Pflichtfelder</label>
  </div>
);
